import { useQuery } from '@tanstack/react-query';
import type { AgentApiCandidateImportRequestsIndex } from '@/types/serializers';

export default function useCandidateImportHistory(page: number = 1) {
  return useQuery({
    queryKey: ['candidateImportHistory', page],
    queryFn: async () => {
      const response = await fetch(`/agent/api/candidate_import_requests.json?page=${page}`);
      const data: AgentApiCandidateImportRequestsIndex = await response.json();
      return data;
    },
  });
}
